import React from 'react';
import {Select} from 'rctui';

const ComboBox = React.createClass({
  displayName: 'Form.ComboBox',

  getDefaultProps: function () {
    return {
      disabled: false,
      options: [],
      name: '',
      value: ''
    };
  },

  propTypes: {
    name: React.PropTypes.string
  },

  onChange: function (value) {
    let v = (value >= this.props.options.length) ? this.props.value : this.props.options[value].value;
    this.props.onChange(this.props.name, v);
  },

  render: function () {
    let data = [];
    let curId = this.props.options.length;

    for (let i = 0; i < this.props.options.length; i++) {
      let option = this.props.options[i];

      if (option.value === this.props.value) {
        curId = i;
      }

      data.push({id: i, text: i18n.get(option.label)});
    }

    // current value is not present in options, so just add it
    if (curId == this.props.options.length) {
      data.push({id: curId, text: this.props.value});
    }

    if (this.props.sorted) {
      data.sort((a, b) => (a.text < b.text ? -1 : (a.text > b.text ? 1 : 0)));
    }

    return <Select grid={this.props.grid} value={curId} required filterAble
                   data={data}
                   onChange={this.onChange}
                   readOnly={this.props.disabled}
                   className={this.props.className}/>;
  }
});

export default ComboBox;



// WEBPACK FOOTER //
// ./src/js/Component/Form/ComboBox.jsx